import type { PddDailyRecord } from './pinduoduo'

export interface PinduoduoAdvertisingSummary {
  requestedDays: number
  coveredDays: number
  confirmedZeroSpendDays: number
  complete: boolean
  spend: number
  missingDates: string[]
}

export interface PinduoduoConfirmedZeroSpendPeriod {
  startDate: string
  endDate: string
}

const spendAvailable = (record: PddDailyRecord | undefined) =>
  record?.dataState.spend === 'reported' && typeof record.spend === 'number'

export function summarizePinduoduoAdvertising(
  daily: PddDailyRecord[],
  dates: string[],
  confirmedZeroSpendPeriods: PinduoduoConfirmedZeroSpendPeriod[] = [],
): PinduoduoAdvertisingSummary {
  const recordsByDate = new Map(daily.map((record) => [record.date, record]))
  const isConfirmedZeroSpend = (date: string) => confirmedZeroSpendPeriods.some((period) =>
    date >= period.startDate && date <= period.endDate,
  )
  const reported = dates.flatMap((date) => {
    const record = recordsByDate.get(date)
    return spendAvailable(record) ? [record!] : []
  })
  const confirmedZeroDates = dates.filter((date) =>
    !spendAvailable(recordsByDate.get(date)) && isConfirmedZeroSpend(date),
  )
  const missingDates = dates.filter((date) =>
    !spendAvailable(recordsByDate.get(date)) && !isConfirmedZeroSpend(date),
  )
  const coveredDays = reported.length + confirmedZeroDates.length
  return {
    requestedDays: dates.length,
    coveredDays,
    confirmedZeroSpendDays: confirmedZeroDates.length,
    complete: dates.length > 0 && coveredDays === dates.length,
    spend: reported.reduce((sum, record) => sum + (record.spend || 0), 0),
    missingDates,
  }
}

export function pinduoduoProfitAfterAdvertising(
  profitWithRebate: number | null,
  advertising: PinduoduoAdvertisingSummary,
) {
  return advertising.complete && profitWithRebate !== null
    ? profitWithRebate - advertising.spend
    : null
}
